import { render, staticRenderFns } from "./ProductStockModal.vue?vue&type=template&id=8cd5bf7e&"
import script from "./ProductStockModal.vue?vue&type=script&lang=js&"
export * from "./ProductStockModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8cd5bf7e')) {
      api.createRecord('8cd5bf7e', component.options)
    } else {
      api.reload('8cd5bf7e', component.options)
    }
    module.hot.accept("./ProductStockModal.vue?vue&type=template&id=8cd5bf7e&", function () {
      api.rerender('8cd5bf7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/carnival/basic/stock/modules/ProductStockModal.vue"
export default component.exports